export default "__VITE_ASSET__f7a94b33__"